(() => {
const isPurchasePath = value => {
try { const url = new URL(value, location.origin); return url.origin === location.origin && /(^|\/)(cart|checkout|checkouts)(\/|$|\.)/.test(url.pathname); } catch { return false; }
};
document.addEventListener('submit', event => {
if (isPurchasePath(event.target.action) || event.submitter?.name === 'checkout' || event.submitter?.name === 'add') {
event.preventDefault(); event.stopImmediatePropagation(); location.assign('/pages/contact');
}
}, true);
document.addEventListener('click', event => {
const target = event.target.closest('a,button,input[type="submit"]');
if (target && ((target.tagName === 'A' && isPurchasePath(target.href)) || target.name === 'checkout' || target.name === 'add')) {
event.preventDefault(); event.stopImmediatePropagation(); location.assign('/pages/contact');
}
}, true);
})();